import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { IUserAvatar, UserAvatarColor, UserAvatarSize } from '@aston/user-badge';

@Component({
	selector: 'user-avatar',
	templateUrl: './user-avatar.component.html',
	imports: [NgbTooltipModule, TranslateModule]
})
export class UserAvatarComponent {
	@Input() hasFullName = false;
	@Input() isSystem = false;

	@Input() user: IUserAvatar = {
		initials: 'AB',
		fullName: 'Username',
		profilePictureUrl: null,
		color: UserAvatarColor.PINK,
		size: UserAvatarSize.MD
	};
}
